export const enum TICKET_TYPES {
  WALKABOUT = 1,
  WILL_CALL = 2,
  DIGITAL = 3,
}
